import { FAQItem } from '@/components/seo/FAQSection';
import { SportType } from '@/types';
import { generalFaqs, sportFaqsBySport } from './seoFaqs.js';

export const faqGeneral: FAQItem[] = generalFaqs;
export const faqBySport: Record<SportType, FAQItem[]> = sportFaqsBySport;

export const faqNBA: FAQItem[] = faqBySport.nba;

export const getSportFaqs = (sport: SportType): FAQItem[] => faqBySport[sport] || [];
